import { Component, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';
moment.locale('zh-cn');
import AirPortTicket from '../../../components/AirPortTicket.vue';
import SelectAirport from '../../../components/SelectAirport.vue';
import changeAirport from '../../../assets/js/airport/changeAirport';

import { TimeSelect } from 'element-ui';
import { NoticeBar } from 'vant';

Vue.use(TimeSelect);
Vue.use(NoticeBar);
@Component({
  components: {
    AirPortTicket,
    SelectAirport,
  },
  // 过滤器 格式化金额
  filters: {
    Money(data: number) {
      return typeof (data) === 'number' ? '+' + data.toFixed(2) : data;
    },
    Date(data: string) {
      return moment(data).format('MM月DD日 dddd');
    },
    OrderBtnPrice(data: number) {
      return [3, 4].indexOf(data) === -1 ? '价格排序' : (data === 3 ? '价格升序' : '价格降序');
    },
    OrderBtnDate(data: number) {
      return [1, 2].indexOf(data) === -1 ? '时间排序' : (data === 1 ? '时间升序' : '时间降序');
    },
    AirPort(data: string) {
      return changeAirport.changeAirportCode(data).airportCName;
    },
    AirLine(data: string) {
      return changeAirport.changeAirCompany(data);
    },
  },
})
export default class AirTicketBooking extends Vue {
  private $api: any;
  private airportlist: any = [];
  private loading: boolean = false;
  private loadError = false; // 加载失败
  private pageIndex = 1;
  private AirTicketFor: any;  // 订票 改签 重订 查看? 'booking' 'change' 'rebooking' 'auditAir'
  private userRoleType: number = 0;       // 用户类型 0(普通员工) 1(总经理) 2(订票专员)
  private isfirstGetAirport: boolean = true;  // 是否第一次获取航班
  private currentTrip: any = '';              // 当前选择的行程 (用于填充查询项)
  private AirTicketTrip: any = '';            // 订票使用的行程 (用于传递给提交页)
  private startDate: any = moment().format('YYYY-MM-DD'); // 出发时间
  private startPlace: any = '';  // 出发地
  private endPlace: any = '';    // 目的地
  private Order: number = 3;  // 排序类型

  private departStartTime: string = '00:00'; // 起始时间段
  private departEndTime: string = '24:00'; // 结束时间段

  private IsNeedLimitDataCount: boolean = true; // 区别在审核页面（传入false）进入时，需查看所有机票，其他入口（默认传true）进入时查看两张最低票价机票

  // 时间选择器
  private show: boolean = false;
  private minDate: any = new Date();
  private currentDate: any = new Date();


  // 初始化
  private created() {
    this.AirTicketFor = localStorage.getItem('AirTicketFor') || '';
    this.AirTicketTrip = localStorage.getItem('AirTicketTrip') || '';
    this.currentTrip = JSON.parse(localStorage.getItem('CurrentTripInfo') || '');
    this.AirTicketFor = localStorage.getItem('AirTicketFor') || ''; // 订票or改签   'booking' or 'change' or 'rebooking'
    if (this.AirTicketFor === 'auditAir') {
      this.IsNeedLimitDataCount = false;
    }
    if (!this.currentTrip) {
      return;
    }
    this.startPlace = {
      airportCode: this.currentTrip.StartAirport ? this.currentTrip.StartAirport : this.currentTrip.TicketStartAirport, cityCName: changeAirport.changeAirportCode(this.currentTrip.StartAirport ? this.currentTrip.StartAirport : this.currentTrip.TicketStartAirport).cityCName,
    };
    this.endPlace = {
      airportCode: this.currentTrip.EndAirport ? this.currentTrip.EndAirport : this.currentTrip.TicketEndAirport, cityCName: changeAirport.changeAirportCode(this.currentTrip.EndAirport ? this.currentTrip.EndAirport : this.currentTrip.TicketEndAirport).cityCName,
    };
    this.startDate = moment(this.currentTrip.AirlineStartTime || this.currentTrip.StartTime).format('YYYY-MM-DD');

    this.departStartTime = this.currentTrip.departStartTime || '00:00';
    this.departEndTime = this.currentTrip.departEndTime || '23:59';

  }

  // 获取出差开始时间
  private async getBussinessTripStartTime() {
    // 帮订的票改签没有出差和行程
    if (this.currentTrip && this.currentTrip.BusinessTripInfoId) {
      const result = await this.$api.httpGet('Membership/BusinessTripInfo/DataByIdNew', { Id: this.currentTrip.BusinessTripInfoId });
      if (result.Success) {
        const startTime = result.Data.BeginAt;
        this.minDate = (moment(startTime).isSameOrAfter(moment()) ? moment(startTime) : moment()).toDate();
      }
    }
  }


  // 设置排序 DeparTime: 1 正序 2 倒序 Price: 3 正序 4 倒序
  private changeOrder(type: string) {
    if (type === 'price') {
      this.Order = [3, 4].indexOf(this.Order) === -1 ? 3 : (this.Order === 3 ? 4 : 3);
    } else if (type === 'date') {
      this.Order = [1, 2].indexOf(this.Order) === -1 ? 1 : (this.Order === 1 ? 2 : 1);
    }
    this.getAirportList();
  }

  // 获取航班列表
  private async getAirportList() {
    const params = {
      Depart: this.startPlace.airportCode,
      Arrive: this.endPlace.airportCode,
      DepartDate: this.startDate,
      Order: this.Order,
      Airline: null,
      Id: null,
      departStartTime: this.departStartTime,
      departEndTime: this.departEndTime,
      IsNeedLimitDataCount: this.IsNeedLimitDataCount,
    };
    if (params.departEndTime === '24:00') {
      params.departEndTime = '23:59';
    }
    // 如果是改签，传入航班，用于过滤列表中的不同航班
    if (this.AirTicketFor === 'changeAir' && this.AirTicketTrip) {
      const AirTicketTrip = JSON.parse(this.AirTicketTrip);
      params.Airline = AirTicketTrip.AirlineName;
      params.Id = AirTicketTrip.Id;
    }
    if (!(params.Depart && params.Arrive)) {
      return;
    }

    if (this.currentTrip.BeginAt && this.currentTrip.EndAt) {
      if (moment(params.DepartDate + ' ' + params.departStartTime).toDate() < moment(this.currentTrip.BeginAt).toDate() || moment(params.DepartDate + ' ' + params.departEndTime).toDate() > moment(this.currentTrip.EndAt).toDate()) {
        this.$toast('您选择的航班时间不在您的出差时间范围内 ' + moment(this.currentTrip.BeginAt).format('YYYY-MM-DD HH:mm') + '-' + moment(this.currentTrip.EndAt).format('YYYY-MM-DD HH:mm') + '，请重新选择，或更改您的出差申请时间后再预订机票。');
        return;
      }
    }


    this.loading = true;  // 显示加载中字样
    this.loadError = false;
    this.isfirstGetAirport = false;
    this.airportlist = null;
    const result = await this.$api.httpPost('basic/Ticket/QueryAirTicketList', params);
    if (result.Success) {
      // console.log(result.Data);
      this.airportlist = result.Data;
    } else {
      this.loadError = true;
      this.$toast(`查询失败${result.AllMessages}`);
    }
    this.loading = false;
  }

  // 预订按钮
  private booking(airport: any) {
    localStorage.setItem('AirTicketFor', this.AirTicketFor);
    localStorage.setItem('AirTicketTrip', this.AirTicketTrip);
    localStorage.setItem('CurrentAirport', JSON.stringify(airport));
    this.$router.push('/airticket-choose');
  }

  // life cycle
  private mounted() {
    this.getAirportList();
    this.getUserIsCommissioner();
  }

  // 弹出时间选择器
  private pickDate() {
    this.show = true;
  }
  // 确定时间
  private changeDate(value: string) {
    this.startDate = moment(value).format('YYYY-MM-DD');
    this.getAirportList();
    this.show = false;
  }

  // 格式化时间
  private formatter(type: string, value: string) {
    if (type === 'year') {
      return `${value}年`;
    } else if (type === 'month') {
      return `${value}月`;
    }
    return `${value}日`;
  }

  // 获取用户角色，是否为订票专员
  private async getUserIsCommissioner() {
    const result = await this.$api.httpGet('Membership/TripBookTicket/GetIsBookingTicketRole');
    if (result.Success) {
      // console.log(result.Data);
      this.userRoleType = result.Data ? 2 : 0;
      // 2020.3.18 运维
      // 如果是订票专员通过行程进入，走普通员工的流程
      if (this.AirTicketTrip && result.Data) {
        this.userRoleType = 0;

      }

      // 不是订票专员 判断总经理
      if (this.userRoleType !== 2) {
        const result2 = await this.$api.httpGet('Membership/TripBookTicket/GetIsDepartGeneralLeaderRole');
        if (result2.Success) {
          this.userRoleType = result2.Data ? 1 : 0;
        }
      }
     
      if (this.userRoleType === 0) {
        // 对普通员工 日期选择器最小可选日期设置为出差的开始时间
        this.getBussinessTripStartTime();
      }
    }
  }

  // 返回帮订
  private backToHelp() {
    if (this.userRoleType === 2 && this.AirTicketFor === 'booking') {
      const params = {
        Depart: this.startPlace.airportCode,
        Arrive: this.endPlace.airportCode,
        DepartDate: this.startDate,
        Order: this.Order,
      };
      localStorage.setItem('AirTicketHelp', JSON.stringify(params));
      this.$router.push('/airticket-help');
    }
  }

  // 返回审批
  private goBack() {
    this.$router.go(-1);
  }

  // +1 日期格式
  private filterTime(time: string) {
    return time ? (time.indexOf('+1') !== -1 ? time.replace(/\+1/g, '<span class="nextday">+1天</span>') : time) : '';
  }

  // 时间段查询
  private search() {
    this.getAirportList();
  }
}
